import { gql } from '@apollo/client';

export const RACE_FIELDS = gql`
  fragment RaceFields on Race {
    race_id
    race_number
    race_name
    status
    distance
    class
    track_condition
    prize_money
    age_restrictions
    sex_restrictions
    weight_type
    sectional_distance
    sectional_time
    race_time
  }
`;
